import { z } from 'zod/v4';

import { deviceStatsSchema } from './device-stats.schema';

export const deviceStatsLocationDetailsSchema = deviceStatsSchema.extend({
  name: z.string(),
});

export type DeviceStatsLocationDetails = z.infer<
  typeof deviceStatsLocationDetailsSchema
>;
